var Handlebars = require("/software/galaxy/personal/sveinugu/galaxy_dev/client/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<input type=\"text\" name=\"query\" placeholder=\""
    + alias4(((helper = (helper = helpers.search_hint_string || (depth0 != null ? depth0.search_hint_string : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"search_hint_string","hash":{},"data":data}) : helper)))
    + "\" id=\"tool-search-query\" autocomplete=\"off\" class=\"search-query parent-width\" />\n<a id=\"search-clear-btn\" title=\"clear search (esc)\"> </a>\n<img src=\""
    + alias4(((helper = (helper = helpers.spinner_url || (depth0 != null ? depth0.spinner_url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"spinner_url","hash":{},"data":data}) : helper)))
    + "\" id=\"search-spinner\" class=\"search-spinner\"/>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./galaxy/scripts/templates/tool_search.handlebars
// module id = 66
// module chunks = 0 3